import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="comprar" className="w-full bg-gradient-to-b from-mint to-mint-dark px-6 py-24 text-center text-white sm:px-10" data-id="element-63" data-mp="c6iultloo175">
      <div className="mx-auto max-w-2xl" data-id="element-64" data-mp="844911qmqnc6">
        <h2 className="font-heading text-3xl font-bold leading-tight sm:text-4xl" data-id="element-65" data-mp="879xcerfpl6u">
          Empezá hoy a sentirte más liviana
          <span className="mt-2 block text-xl font-normal sm:text-2xl" data-id="element-66" data-mp="h653xrye4xao">después de cada comida</span>
        </h2>

        <div className="mt-10" data-id="element-67" data-mp="vv1cdq4d0cbt">
          <p className="text-lg font-bold" data-id="element-68" data-mp="vu8ezfraiz6c">245 recetas + 5 bonos (valor €175)</p>
          <p className="mt-2 text-sm text-white/85" data-id="element-69" data-mp="qwq3bhlw25un">
            6 tomos + planificador anual + listas de compra + reemplazos + etiquetas + diario
          </p>
        </div>

        <p className="mt-8 font-heading text-4xl font-bold text-amber" data-id="element-70" data-mp="zwv9xpj9d07r">Hoy: solo €17,99</p>

        <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className="mt-8 inline-flex w-full items-center justify-center rounded-lg bg-coral px-10 py-5 text-xl font-bold text-white shadow-xl transition-colors duration-150 ease-out hover:bg-coral-dark sm:w-auto sm:min-w-[500px]" data-id="element-71" data-mp="2c4wnqnfjiagv">
          Sí, quiero acceso ahora
        </a>

        <div className="mt-10 flex flex-col items-center gap-3 text-sm sm:flex-row sm:justify-center sm:gap-6" data-id="element-72" data-mp="2qzujlq9wdi2p">
          <span className="flex items-center gap-2" data-id="element-73" data-mp="302lw7teiejvx">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-74" data-mp="301aq3mxld01n" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-75" data-mp="34un1uwh69ccz">
            <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-76" data-mp="39sf34h3piatu" /> Acceso inmediato tras compra
          </span>
          <span className="flex items-center gap-2" data-id="element-77" data-mp="3errsp9lypw04">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="3etco11g3piz1" /> Garantía 7 días
          </span>
        </div>
      </div>
    </section>;
}